/* eslint-disable @typescript-eslint/no-unused-vars */
import _ from 'underscore';

import {
  Button as ReactButton,
  Checkbox as ReactCheckbox,
  Input as ReactInput,
  Select as ReactSelect,
  TextArea as ReactTextArea,
  // Form as ReactForm,
  Radio as ReactRadio,
  RadioGroup as ReactRadioGroup,
} from '@bingads-webui-react/primitive';

import {
  withSignal,
  CommonEventParser,
} from '@bingads-webui-react/hoc-with-signal';

export const Button = withSignal(ReactButton, {
  onClick: CommonEventParser,
}) as typeof ReactButton;

export const Checkbox = withSignal(ReactCheckbox, {
  onChange: CommonEventParser,
}) as typeof ReactCheckbox;

export const Input = withSignal(ReactInput, {
  onChange: CommonEventParser,
}) as typeof ReactInput;

export const Select = withSignal(ReactSelect, {
  onChange: CommonEventParser,
}) as typeof ReactSelect;

export const TextArea = withSignal(ReactTextArea, {
  onChange: CommonEventParser,
}) as typeof ReactTextArea;

export const Radio = withSignal(ReactRadio, {
  onChange: CommonEventParser,
}) as typeof ReactRadio;

export const RadioGroup = withSignal(ReactRadioGroup, {
  onChange: CommonEventParser,
}) as typeof ReactRadioGroup;
